<template>
  <div>
    <!-- <p>
     Attainment inputs=> datas used to generate attainment report. eg: score of  a student in an assessment question 
Assessment Tools => assessment, assignment, survey, university exam
Direct Assessment Tools => assessment, assignment, university exam
Indirect Assessment Tools => Survey



Choose Course outcomes: 
the selected course outcomes will be considered for generating attainment report, 
also in each module (assessment, assignment, survey, etc..) attainment inputs that are linked to these course outcomes will be used for generating attainment 

Confirm selected CO's 

Choose Students: Attainment inputs from the selected students will be considered for report

confirm Students selection

Attainment Config: here you can configure the attainment calculation constants 
or leave with default values if you dont want to customize
first part=> To find the Direct attainment level of a Course outcome after calculating the attainment level of each direct assessment Tool
by default each Assessment Tools have Equal Weightage on Direct attainment level or you can configure here
second => when finding the Final Attainment level of a CO, you can configure the weightage Direct and indirect attainment level
third => 


Activity View Data => each column contain score of a student in a question(question number, related CO, Activity name) 
Activity View Report => each column contain % of total score of a student in a CO. 
% of student in CO1 = [(score of student in question1 linked to CO1/ maximum mark of question1) + 
(score of student in question2 linked to CO1/ maximum mark of question2)+... ]/number of questions linked to CO1  
Target Achieved Student Count for CO1 = number of student score in CO1 grated than target value<input>
Target Achieved Student % = Target Achieved Student Count * 100 / Max Students Count
Attainment Level = compare the Target Achieved Student % with Attainment level table<input>

Survey : Avg. value of a question =  [ (score of choice1 * count of choice1) + (score of choice2 * count of choice2) + ... ] / sum of count or no. of students
Survey : % of a question =  [ (score of choice1 * count of choice1) + (score of choice2 * count of choice2) + ... ] / (sum of count * maximum score of choice in question)
Survey : attainment level of CO1 = 3/ 100 * average of % of a questions linked to CO1

university exam :
Target Achieved Student Count = number of student score grated than target value<input>
Target Achieved Student % = Target Achieved Student Count * 100 / Max Students Count
Attainment Level of CO (all CO have same value) = compare the Target Achieved Student % with Attainment level table<input>

Final Attainment value:

Final Attainment value of CO1 (equal assessment tool weightage) =  [Direct weightage/100 * ([assessment+assignment+university exam]/3)] + (Indirect weightage/100 * survey)

Final Attainment value of CO1 (custom assessment tool weightage) =  [Direct weightage/100 * (
[(assessment*assessment weightage/100) + 
(assignment*assignment weightage/100)+
(universityExam*universityExam weightage/100)
]/3
)] + (Indirect weightage/100 * survey)


    </p> -->
    <div class="courseReports">
      <b-overlay :show="loadData" spinner-variant="primary" spinner-type="grow" spinner-small rounded="md">
        <div class="attainment">
          <b-row>
            <b-col md="12">
              <div class="d-flex justify-content-end">
                <!-- <b-button variant="danger" @click="goBack" size="md" :disabled="activeAttainment == 0">Back</b-button> -->
                <div v-if="isConfig">
                  <!-- <b-button variant="primary" :disabled="this.buttondisable" size="md" @click="proceedToNext">{{
                      activeAttainment == attaimentOptions.length - 1
                        ? "Save & Finish"
                        : "Next"
                  }}</b-button> -->
                  <b-button class="mr-2" variant="primary" :disabled="exportExcelBtn.disabled" @click="exportCoAttainmentToExcel"
                    size="md">{{ exportExcelBtn.text }}</b-button>
                  <b-button v-if="isConfig" variant="success" @click="finish" size="md">Save & Generate Report</b-button>
                </div>
              </div>
              <br />
            </b-col>
            <b-col md="12" v-if="isConfig">
              <b-list-group horizontal>
                <b-list-group-item v-for="(attainment, attainmentIndex) in attaimentOptions" :key="attainmentIndex" class="red"
                  :active="activeAttainment == attainmentIndex ? true : false" button @click="switchComponent(attainment, attainmentIndex)">
                  {{ attainment.name }}
                </b-list-group-item>
              </b-list-group>
              <div v-if="errorMessage">
                <p class="text-danger">{{ errorMessage }}</p>
              </div>
              <br />
            </b-col>
            <b-col md="12">
              <!-- <div class="d-flex justify-content-end">
                <b-button v-if="isConfig" variant="success" @click="save" size="md" :disabled="this.buttondisable">{{this.buttondisable ? 'Saved' : 'Save'}}</b-button>
              </div> -->
              <component v-bind:is="currentComponent" :courseReport="courseReport" :courseDetails="course"
                :ref="currentComponent" @configure-clicked="handleConfigure" @onWeightage-change="handleWeightageChange"></component>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import CourseOutcomes from "./CourseOutcomes.vue";
import StudentList from "./StudentList.vue";
import Survey from "./Survey.vue";
import CoPoPsoMapping from "./CoPoPsoMapping.vue";
import TheAttainment from "./TheAttainment.vue";
import AttainmentReport from "./AttainmentReport.vue";
import XLSX from "xlsx";
export default {
  props: ["courseReport"],
  async created() {
    this.loadData = true;
    // console.log(this.attaimentOptions);
    await this.getCourse();
    await this.getAttainmentConfigration();
    this.loadData = false;
  },
  components: {
    CourseOutcomes,
    StudentList,
    Survey,
    TheAttainment,
    AttainmentReport,
    CoPoPsoMapping,
  },
  data() {
    return {
      loadData: false,
      buttondisable:false,
      attaimentOptions: [
        // { name: "Course CO Attainment", component: "AttainmentReport" },
        { name: "Course Outcomes", component: "CourseOutcomes" },
        { name: "Students List", component: "StudentList" },
        { name: "Configure", component: "TheAttainment" },
        // { name: "Assignments", component: "Assignments" },
        // { name: "Assessments", component: "Assessments" },
        // { name: "Laboratory", component: "Laboratory" },
        // { name: "Project", component: "Project" },
        // { name: "Seminar", component: "Seminar" },
        { name: "University Exams", component: "BoardExams" },
        { name: "Survey", component: "Survey" },
        { name: "CO PO PSO Mapping", component: "CoPoPsoMapping" },        
      ],
      cie_weightage: {
        assessment: null,
        assignment: null,
        laboratory: null,
        project: null,
        seminar: null,
        boardexam: null,
      },
      activeAttainment: 0,
      currentComponent: "AttainmentReport",
      course: {},
      isConfig: false,
      errorMessage : null,
      exportExcelBtn: {
        text: "Export to Excel",
        disabled: false,
      },
    };
  },
  computed: {
    handleComponent() {
      if (
        this.currentComponent != "" &&
        this.$refs[this.currentComponent] &&
        this.$refs[this.currentComponent].config == true
      ) {
        alert();
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    handleConfigure() {
      this.activeAttainment = 0;
      this.currentComponent = 'CourseOutcomes';
      this.isConfig = true;
    },
    async switchComponent(attainment, index) {
      this.buttondisable = false;

      if(await this.save()){ //If cie sum check fails, don't switch to other component

        this.activeAttainment = index;
        this.currentComponent = attainment.component;

      }

    },
    async save(){

      this.buttondisable = true;
      const reportComponent = await this.$refs[this.currentComponent];

      if (this.currentComponent === "TheAttainment" && !reportComponent.proceedNextCheck()) {
          this.buttondisable = false;
          return false;
      }
      if(this.currentComponent == "TheAttainment" && reportComponent.proceedNextCheck()){

          this.cie_weightage = reportComponent.assesmenttools_weightage;
          await this.filterAttainmentOptions();
          await this.loadDynamicComponents(); 

      }

      let setSuccess = await reportComponent.setAttainmentConfigration();

      if(setSuccess === false) return;
      
      if (reportComponent.getAttainmentData) await reportComponent.getAttainmentData();

      if (reportComponent.getAttainmentReport) await reportComponent.getAttainmentReport();      
      
      this.buttondisable = false;
      return true;
    },
    async handleWeightageChange(weightage){ //On weightage change, load dynamic tabs

      this.cie_weightage = weightage;
      await this.filterAttainmentOptions();
      await this.loadDynamicComponents();

    },
    async finish(){


      await this.save();
      const response = await this.recalculate();
      console.log('response',response);
      if(!response) return

      this.saveAttainmentConfigs();
      this.currentComponent = 'AttainmentReport';
      this.isConfig = false;
      
    },
    async filterAttainmentOptions() {
      const weightage = this.cie_weightage;

      // Build conditionally based on weightage values
      this.attaimentOptions = [
        { name: "Course Outcomes", component: "CourseOutcomes" },
        { name: "Students List", component: "StudentList" },
        { name: "Configure", component: "TheAttainment" },
        ...((weightage.assignment && weightage.assignment !=0) ? [{ name: "Assignments", component: "Assignments" }] : []),
        ...((weightage.assessment && weightage.assessment !=0) ? [{ name: "Assessments", component: "Assessments" }] : []),
        ...((weightage.laboratory && weightage.laboratory !=0) ? [{ name: "Laboratory", component: "Laboratory" }] : []),
        ...((weightage.project && weightage.project !=0) ? [{ name: "Project", component: "Project" }] : []),
        ...((weightage.seminar && weightage.seminar !=0) ? [{ name: "Seminar", component: "Seminar" }] : []),
        ...((weightage.boardexam && weightage.boardexam !=0) ? [{ name: "University Exams", component: "BoardExams" }] : []),
        { name: "Survey", component: "Survey" },
        { name: "CO PO PSO Mapping", component: "CoPoPsoMapping" },
        //{ name: "Course CO Attainment", component: "AttainmentReport" },
      ];
    },
    async loadDynamicComponents() {
      const dynamicComponents = {};

      if (this.cie_weightage.assignment && this.cie_weightage.assignment !=0) {
        dynamicComponents.Assignments = (await import('./Assignments.vue')).default;
      }
      if (this.cie_weightage.assessment && this.cie_weightage.assessment !=0) {
        dynamicComponents.Assessments = (await import('./Assessments.vue')).default;
      }
      if (this.cie_weightage.laboratory && this.cie_weightage.laboratory !=0) {
        dynamicComponents.Laboratory = (await import('./laboratory.vue')).default;
      }
      if (this.cie_weightage.project && this.cie_weightage.project !=0) {
        dynamicComponents.Project = (await import('./project.vue')).default;
      }
      if (this.cie_weightage.seminar && this.cie_weightage.seminar !=0) {
        dynamicComponents.Seminar = (await import('./seminar.vue')).default;
      }
      if (this.cie_weightage.boardexam && this.cie_weightage.boardexam !=0) {
        dynamicComponents.BoardExams = (await import('./BoardExams.vue')).default;
      }

      // Add to component list
      Object.assign(this.$options.components, dynamicComponents);
    },
    async proceedToNext() {   
      const reportComponent = await this.$refs[this.currentComponent];

      console.log('this',reportComponent);
      this.loadData = true;     
      if (
        this.activeAttainment != this.attaimentOptions.length - 1 &&
        reportComponent.config
      ) {
        const data = await reportComponent.setAttainmentConfigration();
        console.log('1');
        data;
        if (["TheAttainment", "CourseOutcomes", "StudentList"].includes(this.currentComponent)) {
          console.log('2');
            if (this.currentComponent === "TheAttainment") {
              console.log('3');
            if (reportComponent.proceedNextCheck()) {
              console.log('4');
              if (reportComponent && reportComponent.assesmenttools_weightage) {
                console.log('5');
                this.cie_weightage = reportComponent.assesmenttools_weightage;
              }
              await this.filterAttainmentOptions();
              await this.loadDynamicComponents(); 
              this.activeAttainment = (await this.activeAttainment) + 1;
              this.currentComponent = await this.attaimentOptions[this.activeAttainment].component;
            } else {
              console.log('6');
              this.loadData = false; 
              return;
            }
          } else {
            console.log('7');
            this.activeAttainment = (await this.activeAttainment) + 1;
            this.currentComponent = await this.attaimentOptions[this.activeAttainment].component;
          }
        }
         else {
            console.log('7.1');
            this.activeAttainment = (await this.activeAttainment) + 1;
            this.currentComponent = await this.attaimentOptions[this.activeAttainment].component;
          }

        // if (reportComponent.skip !=undefined && reportComponent.skip==true) {
        //   this.activeAttainment = (await this.activeAttainment) + 1;
        //   this.currentComponent = await this.attaimentOptions[
        //     this.activeAttainment
        //   ].component;
        // }else{
        if (reportComponent.getAttainmentData) {
          console.log('8');
          await reportComponent.getAttainmentData();
        }
        if (reportComponent.getAttainmentReport) {
          console.log('9');
          await reportComponent.getAttainmentReport();
        }
        // }
        console.log(reportComponent.$options._componentTag);
        // reportComponent.config = false;

        await this.$refs.currentComponent;
      } else if (this.activeAttainment != this.attaimentOptions.length - 1) {
        console.log('10');
        if (reportComponent.report != undefined && !reportComponent.report) {
          console.log('11');
          this.loadData = false;
          return (reportComponent.report = true);
        }
        this.activeAttainment = (await this.activeAttainment) + 1;
        this.currentComponent = await this.attaimentOptions[
          this.activeAttainment
        ].component;
      } else {
        console.log('12');
        reportComponent.setAttainmentConfigration();
        this.saveAttainmentConfigs();
        this.isConfig = false;
        this.currentComponent = 'AttainmentReport';
        // this.$emit("finishAttainment");
      }
      this.loadData = false;
    },
    async saveAttainmentConfigs() {
        const url =
            this.$store.getters.getAPIKey.mainAPI +
            `/coattainment/savedata`;
        await this.$axios
            .post(url, {
                course: this.courseReport.course_id
            })
            .then(() => {
                this.$toast.success('Configuration saved successfully', {
                    position: "top",
                    duration: 3000,
                });
            })
            .catch(() => {
                this.$toast.error('Failed save configuration', {
                    position: "top",
                    duration: 5000,
                });
            });
        },
    async goBack() {
      this.buttondisable=false;
      const reportComponent = await this.$refs[this.currentComponent];
      if (reportComponent.config != undefined && !reportComponent.config) {
        reportComponent.config = true;
      } else {
        this.activeAttainment = (await this.activeAttainment) - 1;
        this.currentComponent = await this.attaimentOptions[
          this.activeAttainment
        ].component;
      }
    },

    async getCourse() {
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/courses/${this.courseReport.course_id}`;
      await this.$axios
        .get(url)
        .then((response) => {
          this.course = response.data;
        });
    },

    async getAttainmentConfigration() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      await this.$axios
        .post(url, { course: this.courseReport.course_id, step: 'configure' })
        .then((response) => {
          this.cie_weightage = response.data.assesmenttools_weightage;
          this.filterAttainmentOptions();
          this.loadDynamicComponents(); 
        });
    },

    // Reads the current selection for an assignment/assessment step: live checkbox state if that tab is
    // open right now, otherwise whatever was last saved for it (a tab auto-saves when you navigate away).
    async getActivityQuestionSelection(step) {
      const componentName = step === "assignment" ? "Assignments" : "Assessments";
      const liveComponent = this.currentComponent === componentName ? this.$refs[componentName] : null;

      if (liveComponent) {
        const activity_questions = [];
        const co_score_evaluation_activities = [];
        for (const examId in liveComponent.assignmentQuestions) {
          const aq = liveComponent.assignmentQuestions[examId];
          if (aq.checked && aq.co_score_evaluation) co_score_evaluation_activities.push(examId);
          aq.selectedQues.forEach((ques) => activity_questions.push(ques));
        }
        return activity_questions.length ? { activity_questions, co_score_evaluation_activities } : null;
      }

      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      const response = await this.$axios.post(url, { course: this.courseReport.course_id, step });
      const { exams_with_questions, selected_questions, selected_exams } = response.data;
      const co_score_evaluation_activities = exams_with_questions
        .filter((exam) => exam.co_score_evaluation && selected_exams.includes(exam.id))
        .map((exam) => exam.id);
      return selected_questions.length ? { activity_questions: selected_questions, co_score_evaluation_activities } : null;
    },

    // Same idea, but for laboratory: live selected experiments if that tab is open, else last-saved ones.
    async getLaboratoryExperimentSelection() {
      const liveComponent = this.currentComponent === "Laboratory" ? this.$refs["Laboratory"] : null;
      if (liveComponent) {
        return liveComponent.selectedExperiments.length ? { experiments: liveComponent.selectedExperiments } : null;
      }

      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      const response = await this.$axios.post(url, { course: this.courseReport.course_id, step: "laboratory" });
      const selected = response.data.selected_experiments || [];
      return selected.length ? { experiments: selected } : null;
    },

    // Same idea, but for project: live selected methods if that tab is open, else last-saved ones.
    async getProjectMethodSelection() {
      const liveComponent = this.currentComponent === "Project" ? this.$refs["Project"] : null;
      if (liveComponent) {
        return liveComponent.selectedmethods.length ? { methods: liveComponent.selectedmethods } : null;
      }

      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      const response = await this.$axios.post(url, { course: this.courseReport.course_id, step: "project" });
      const selected = response.data.selected_methods || [];
      return selected.length ? { methods: selected } : null;
    },

    // Same idea, but for seminar: live selected methods if that tab is open, else last-saved ones.
    async getSeminarMethodSelection() {
      const liveComponent = this.currentComponent === "Seminar" ? this.$refs["Seminar"] : null;
      if (liveComponent) {
        return liveComponent.selectedmethods.length ? { methods: liveComponent.selectedmethods } : null;
      }

      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      const response = await this.$axios.post(url, { course: this.courseReport.course_id, step: "seminar" });
      const selected = response.data.selected_methods || [];
      return selected.length ? { methods: selected } : null;
    },

    // Same idea, but for university exam: live selected exam/questions if that tab is open, else last-saved ones.
    // Grade-wise (subject_wise) and CO-wise exams don't have questions to select, so only the exam itself is required here -
    // the backend decides per mark_entry_type whether questionIds are actually needed.
    async getBoardExamQuestionSelection() {
      const liveComponent = this.currentComponent === "BoardExams" ? this.$refs["BoardExams"] : null;
      if (liveComponent) {
        return liveComponent.selectedBoardexamId
          ? { boardexamId: liveComponent.selectedBoardexamId, questionIds: liveComponent.selectedQuestionIds }
          : null;
      }

      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      const response = await this.$axios.post(url, { course: this.courseReport.course_id, step: "boardexam" });
      const { selected_boardexam, selected_questions } = response.data;
      return selected_boardexam
        ? { boardexamId: selected_boardexam, questionIds: selected_questions }
        : null;
    },

    // Same idea, but for course exit survey: live selected questions/rubrics if that tab is open, else last-saved ones.
    // Survey isn't part of cie_weightage (it's the indirect tool, always available), so this isn't weightage-gated.
    async getSurveyQuestionSelection() {
      const liveComponent = this.currentComponent === "Survey" ? this.$refs["Survey"] : null;
      if (liveComponent) {
        const survey_questions = [];
        for (const surveyId in liveComponent.assignmentQuestions) {
          liveComponent.assignmentQuestions[surveyId].selectedQues.forEach((ques) => survey_questions.push(ques));
        }
        const rubrics = liveComponent.attainments.filter(
          (a) => a.value !== "" && a.comparisan !== null && a.compare_by !== ""
        );
        return survey_questions.length ? { survey_questions, rubrics } : null;
      }

      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      const response = await this.$axios.post(url, { course: this.courseReport.course_id, step: "courseexitsurvey" });
      const { selected_questions, rubrics } = response.data;
      return (selected_questions || []).length ? { survey_questions: selected_questions, rubrics: rubrics || [] } : null;
    },

    // Same idea, but for CO PO PSO mapping: live checked POs/PSOs if that tab is open, else last-saved ones.
    // Also not weightage-gated - always available, like Survey.
    async getCoPoPsoMappingSelection() {
      const liveComponent = this.currentComponent === "CoPoPsoMapping" ? this.$refs["CoPoPsoMapping"] : null;
      if (liveComponent) {
        const programme_outcomes = liveComponent.programme_outcomes.filter((po) => po.checked).map((po) => po.id);
        const programme_specificoutcomes = liveComponent.programme_specificoutcomes.filter((pso) => pso.checked).map((pso) => pso.id);
        return programme_outcomes.length || programme_specificoutcomes.length
          ? { programme_outcomes, programme_specificoutcomes }
          : null;
      }

      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      const response = await this.$axios.post(url, { course: this.courseReport.course_id, step: "co_po_pso_mapping" });
      const programme_outcomes = response.data.selected_po_ids || [];
      const programme_specificoutcomes = response.data.selected_pso_ids || [];
      return programme_outcomes.length || programme_specificoutcomes.length
        ? { programme_outcomes, programme_specificoutcomes }
        : null;
    },

    // Column width (in characters) sized to the longest cell in each column, clamped to a sane range.
    computeColumnWidths(aoa) {
      const colCount = aoa.reduce((max, row) => Math.max(max, row.length), 0);
      const widths = [];
      for (let c = 0; c < colCount; c++) {
        let maxLen = 8;
        for (const row of aoa) {
          const cell = row[c];
          if (cell === undefined || cell === null || cell === "") continue;
          // multi-line cells (e.g. project parameter cells) should size to their longest line, not the whole string
          const longestLine = String(cell).split("\n").reduce((a, b) => (b.length > a.length ? b : a), "");
          maxLen = Math.max(maxLen, longestLine.length);
        }
        widths.push({ wch: Math.min(maxLen + 2, 40) });
      }
      return widths;
    },

    // Builds one worksheet from an excelexport API response - purely generic, works for any table shape
    // as long as the backend returns header_rows (array of row arrays), merges, and rows (array of row arrays).
    buildAttainmentExcelSheet(data) {
      const aoa = [...data.header_rows, ...data.rows];
      const ws = XLSX.utils.aoa_to_sheet(aoa);
      if (data.merges && data.merges.length) ws["!merges"] = data.merges;
      ws["!cols"] = this.computeColumnWidths(aoa);
      return ws;
    },

    // A tool is only part of the attainment calculation (and so only worth exporting) when it has a non-zero weightage.
    isToolWeightageEnabled(tool) {
      return !!this.cie_weightage[tool] && this.cie_weightage[tool] != 0;
    },

    // Single "Export to Excel" click -> one workbook, one sheet per enabled attainment tool (Assignment, Assessment, Laboratory, ...).
    async exportCoAttainmentToExcel() {
      this.exportExcelBtn = { text: "Please wait...", disabled: true };
      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/report/excelexport`;
      const sheets = [
        { step: "assignment", tool: "assignment", getSelection: () => this.getActivityQuestionSelection("assignment") },
        { step: "assessment", tool: "assessment", getSelection: () => this.getActivityQuestionSelection("assessment") },
        { step: "laboratory", tool: "laboratory", getSelection: () => this.getLaboratoryExperimentSelection() },
        { step: "project", tool: "project", getSelection: () => this.getProjectMethodSelection() },
        { step: "seminar", tool: "seminar", getSelection: () => this.getSeminarMethodSelection() },
        { step: "boardexam", tool: "boardexam", getSelection: () => this.getBoardExamQuestionSelection() },
        { step: "courseexitsurvey", getSelection: () => this.getSurveyQuestionSelection() }, // indirect tool, always available - not weightage-gated
        { step: "co_po_pso_mapping", getSelection: () => this.getCoPoPsoMappingSelection() }, // always available - not weightage-gated
      ].filter(({ tool }) => !tool || this.isToolWeightageEnabled(tool));

      try {
        const wb = XLSX.utils.book_new();
        let fileName = null;

        for (const { step, getSelection } of sheets) {
          const selection = await getSelection();
          if (!selection) continue;

          const response = await this.$axios.post(url, {
            course: this.courseReport.course_id,
            step,
            ...selection,
          });
          (response.data.sheets || []).forEach((sheet) => {
            const ws = this.buildAttainmentExcelSheet(sheet);
            XLSX.utils.book_append_sheet(wb, ws, sheet.name);
          });
          if (!fileName) fileName = response.data.file_name;
        }

        if (wb.SheetNames.length === 0) {
          this.exportExcelBtn = { text: "Export to Excel", disabled: false };
          return this.$toast.warning("Select at least one assignment, assessment or laboratory experiment to export.", {
            position: "top",
            duration: 4000,
          });
        }

        XLSX.writeFile(wb, `${fileName ? fileName.replace(/Of \w+-/, "Report-") : "co_attainment_report"}.xlsx`);
      } catch (error) {
        this.$toast.error(
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : "Failed to export report",
          {
            position: "top",
            duration: 3000,
          }
        );
      }
      this.exportExcelBtn = { text: "Export to Excel", disabled: false };
    },
    async recalculate(){

      this.errorMessage = null;
      const url = this.$store.getters.getAPIKey.mainAPI + `/coattainment/recalculate`;

        try {

          const res = await this.$axios.post(url,{
              course_id: this.courseReport.course_id,
          });

          console.log('res',res);

          this.$toast.success('Configuration completed successfully', {
              position: "top",
              duration: 3000,
          });

          return true;

        } catch (error) {
          // console.log('error',);
          // this.$toast.error(error.response.data.message, {
          //     position: "top",
          //     duration: 5000,
          // });
          this.errorMessage = error.response.data.message;
          return false;

        }

    }
  },
};
</script>

<style >
.attainment .list-group .list-group-item {
  font-family: "Roboto Regular";
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}

.attainment .list-group .list-group-item:focus {
  outline: none;
}
.courseReports .attainment .table-responsive {
  max-height: 400px;
}
</style>
